import styled from "styled-components";
import Dashboard from "../components/Analytic/Dashboard";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { request } from "../utils/axios-utils";
import { Loader } from "../components/UI/Loader";

const AnalyticPage = () => {
  const {
    isLoading: isFetching,
    data: websiteList,
    refetch: refetchUserPanel,
  } = useQuery("user-panel", () => {
    return request({ url: "api/v2/project/list" });
  });

  const { t } = useTranslation();

  if (isFetching) {
    return <Loader />;
  }

  return (
    <Container>
      <TopBox>
        <p>{t("analyticPageHeader")}</p>
      </TopBox>
      <Box>
        {websiteList.data.length ? (
          <Dashboard data={websiteList} refetch={refetchUserPanel} />
        ) : (
          <NoResultMessage>
            <h1>{t("noResult")}</h1>
          </NoResultMessage>
        )}
      </Box>
    </Container>
  );
};

export default AnalyticPage;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;

  & h1 {
    font-size: 24px;
    text-align: center;
  }
`;

const TopBox = styled.div`
  max-width: 65rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  border: none;
  outline: none;
  border-bottom-right-radius: none;
  border-bottom-left-radius: none;
  border-top-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  color: #ffffff;
  background: #9bc2e0;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);

  p {
    font-size: 18px;
    padding: 0 10px;
  }

  @media screen and (max-width: 767px) {
    max-width: 50rem;
  }
`;

const Box = styled.div`
  max-width: 65rem;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2rem 2.5rem;
  flex-direction: column;
  gap: 10px;
  border: none;
  outline: none;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: none;
  border-top-left-radius: none;
  color: #121212;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);

  @media screen and (max-width: 767px) {
    max-width: 50rem;
  }
`;

const NoResultMessage = styled.div`
  padding: 200px 0;
`;
